import React, { Component } from 'react';
import './SessionCheckLoader.scss';

class SessionCheckLoader extends Component {
  render() {
    return (
      <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <span className="session-check-loader"></span>
      </div>
    );
  }
}

export default SessionCheckLoader;
